import { render, staticRenderFns } from "./RouteBreadcrumb.vue?vue&type=template&id=64da2c3e&"
import script from "./RouteBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./RouteBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports